// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://bqvrzttkbmokhvvmallu.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJxdnJ6dHRrYm1va2h2dm1hbGx1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzYwMDMxNDYsImV4cCI6MjA1MTU3OTE0Nn0.KKHg3TpN8NOjre05CoP3pn34jsQ_GpQRW2Wm4-Uw0nY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);